export interface IconSettings {
  values: any[];
  icon: string; /* font awesome class */
}
